var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.22277 1.35188L4.55105 0.680162C4.07125 0.200363 3.28301 0.200363 2.80321 0.680162L2.13149 1.35188C1.99784 1.48554 1.99784 1.70487 2.13149 1.83853L3.43723 3.14427C3.57089 3.27793 3.7868 3.27793 3.92046 3.14427L5.2262 1.83853C5.35643 1.70487 5.35643 1.48554 5.22277 1.35188Z",
    fill: "#7C7C7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.28157 2.20181L0.609849 2.87352C0.13005 3.35332 0.13005 4.14156 0.609849 4.62136L1.28157 5.29308C1.41523 5.42674 1.63113 5.42674 1.76479 5.29308L3.07053 3.98734C3.20419 3.85368 3.20419 3.63778 3.07053 3.50412L1.76822 2.20181C1.63456 2.06815 1.41523 2.06815 1.28157 2.20181Z",
    fill: "#7C7C7C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74452 2.87352L6.0728 2.20181C5.93914 2.06815 5.72323 2.06815 5.58958 2.20181L4.28384 3.50754C4.15018 3.6412 4.15018 3.85711 4.28384 3.99077L5.58958 5.29651C5.72323 5.43017 5.93914 5.43017 6.0728 5.29651L6.74452 4.62479C7.22432 4.14156 7.22432 3.35332 6.74452 2.87352Z",
    fill: "#7C7C7C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.13193 6.14311L2.80364 6.81483C3.28344 7.29463 4.07168 7.29463 4.55148 6.81483L5.2232 6.14311C5.35686 6.00946 5.35686 5.79355 5.2232 5.65989L3.91746 4.35415C3.7838 4.22049 3.5679 4.22049 3.43424 4.35415L2.1285 5.65989C1.99827 5.79012 1.99827 6.00946 2.13193 6.14311Z",
    fill: "#7C7C7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.02a89adbcdef4735a0ca927155f79518.svg";
export { ForwardRef as ReactComponent };